import { ACTIVITY_IMAGE_FILE_KEY_MAX_LENGTH } from 'constants/image';
import { ActivityImagesDataType } from 'interfaces';

const normalizeActivityImageValue = (value?: string): string =>
  typeof value === 'string' ? value.trim() : '';

export const isActivityImageFilePathValid = (filePath?: string): boolean => {
  const normalizedFilePath = normalizeActivityImageValue(filePath);

  return (
    normalizedFilePath.length > 0 &&
    normalizedFilePath.length <= ACTIVITY_IMAGE_FILE_KEY_MAX_LENGTH
  );
};

export const isActivityImageEntryValid = (
  image: ActivityImagesDataType
): boolean => {
  const normalizedUrl = normalizeActivityImageValue(image.url);
  const normalizedFilePath = normalizeActivityImageValue(image.file_path);

  if (normalizedUrl) {
    return true;
  }

  if (!normalizedFilePath) {
    return false;
  }

  return isActivityImageFilePathValid(normalizedFilePath);
};

export const areActivityImagesValid = (
  images: ActivityImagesDataType[] | undefined
): boolean => (images ?? []).every(isActivityImageEntryValid);
